import { render } from "./VerifyUserPhone.vue?vue&type=template&id=0a38601e&scoped=true"
import script from "./VerifyUserPhone.vue?vue&type=script&lang=js"
export * from "./VerifyUserPhone.vue?vue&type=script&lang=js"

import "./VerifyUserPhone.vue?vue&type=style&index=0&id=0a38601e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a38601e"]])

export default __exports__